module.exports = __webpack_public_path__ + "static/media/Adjunta_credencial_frente.e15141f1.gif";